import { useRegisterSW } from "virtual:pwa-register/react";
import { Button } from "@cliently/ui";
import { RefreshCw } from "lucide-react";



export const UpdatePrompt = () => {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!needRefresh) return null;

  return (
    <div className="bg-background fixed bottom-4 right-4 z-50 flex items-center gap-3 rounded-lg border p-4 shadow-lg">
      <p className="text-sm">Une nouvelle version est disponible.</p>
      <Button size="sm" onClick={() => updateServiceWorker(true)}>
        <RefreshCw className="mr-2 h-3.5 w-3.5" />
        Mettre à jour
      </Button>
    </div>
  );
}
